import { Injectable } from '@angular/core';
import { AttributeCreate, AttributeDetail, AttributeEntity, AttributeTermCreate, AttributeUpdate } from '@models';
import { BaseApi } from './_base-api';
import { joinNamesFn } from '../helpers';
import { map } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class AttributeApiService extends BaseApi<AttributeEntity, AttributeCreate, AttributeUpdate> {
  constructor() {
    super('/AdminPanel/GetAttributes', {
      get: '/AdminPanel/GetAttributes',
      post: '/AdminPanel/AddAttribute',
    });
  }

  // @ts-ignore
  override update(data: AttributeUpdate) {
    return http$.put('/AdminPanel/EditAttribute', data);
  }

  // @ts-ignore
  override delete(id: number) {
    return http$.delete('/AdminPanel/DeleteAttribute', { body: { attributeId: id } });
  }

  getDetails(id: number) {
    return http$.get<AttributeDetail>(`/AdminPanel/GetAttribute?AttributeId=${id}`);
  }

  createTermsForAttribute(attributeId: number, terms: AttributeTermCreate[]) {
    return http$.post('/AdminPanel/AddTermForAttribute', {
      attributeId,
      fields: terms,
    });
  }

  deleteTerms(ids: number[]) {
    return http$.delete('/AdminPanel/DeleteAttributeTerm', { body: { attributeValueIds: ids } });
  }
}
